import { SecondaryButton } from "@shared/buttons";
import { Select } from "@shared/selects";
import { TextInput } from "@shared/text-input";

export const NumericFilterForm = () => {
  return (
    <>
      <div className="mb-4">
        <label className="text-xs font-normal mb-1">LOGIC</label>
        <div>
          <Select
            // onChange={(value) => setProposedOperator(value)}
            onChange={() => null}
            placeholder="Operator..."
            // options={operatorOptions}
            options={[]}
            // value={propsedOperator}
            value={null}
            menuClassName="w-[calc(var(--button-width)+10px)]"
          />
        </div>
      </div>
      <div className="nb-input-container">
        <label className="text-xs font-normal mb-1">VALUE</label>
        <div>
          <TextInput
            className="w-full mt-2"
            inputClassName="font-light"
            placeholder="Filter value"
            type="number"
            // value={propsedValue}
            // onChange={(e) => setProposedValue(e.target.value)}
          />
          <div className="text-xxs text-subtitle font-light mt-1">
            For percentages, 1 is 100%
          </div>
        </div>
      </div>
      <div className="mt-3 flex gap-2">
        <SecondaryButton
          className="flex-1 font-semibold"
          // onClick={() => {
          //   onReset();
          //   onClose();
          // }}
        >
          {/* {value !== undefined ? "RESET" : "CANCEL"} */}
          TODO
        </SecondaryButton>
        <SecondaryButton
          className="flex-1 font-semibold"
          // isDisabled={!propsedValue}
          // onClick={() => {
          //   if (propsedValue && propsedOperator) {
          //     onApply(Number(propsedValue), propsedOperator);
          //   }
          //   onClose();
          // }}
        >
          APPLY
        </SecondaryButton>
      </div>
    </>
  );
};
